import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.info;
//VERIFY IF THE JWT IS SET
const getMemberName = createSelector(getData, info => info.name);
export default getMemberName;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberName.js